<template>
  <div>
    <v-container>
      <div>
        <date-filter
          @changeDate="getData"
          :defaultFilter="'today'"
          v-model="selectedDate"
        ></date-filter>
      </div>
      <div class="mt-3">
        <div class="title mb-3">จำนวนและรายชื่อช่างตามสถานะ</div>
        <v-layout row wrap class="mb-0">
          <v-flex xs6>
            <div>
              <multiselect
                v-model="dealertype"
                label="label"
                :allow-empty="false"
                single-select
                :options="optionType"
                @input="getData"
              ></multiselect>
            </div>
          </v-flex>
          <v-flex xs6 class="pt-3">
            <div class="text-xs-right">ทั้งหมด : {{ total }}</div></v-flex
          >
        </v-layout>

        <v-data-table
          v-bind:pagination.sync="pagination"
          :headers="headers"
          :items="data"
          class="elevation-1"
          hide-actions
          :loading="loading"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-center">
                {{ props.item.painter_name }}
              </td>
              <td class="text-xs-center">
                {{ props.item.painter_phoneno }}
              </td>
              <td class="text-xs-center">
                {{ props.item.painter_email }}
              </td>
              <td class="text-xs-center">
                <div v-for="(item, k) in props.item.painter_experience" :key="k">
                  {{ item }}
                </div>
              </td>
              <td class="text-xs-center">
                <div>
                  {{
                    `${props.item.painter_address1} เขต${props.item.painter_sub_district} แขวง${props.item.painter_district} จังหวัด${props.item.painter_province} เลขไปรษณีย์${props.item.painter_zip_code} `
                  }}
                </div>
              </td>
              <td class="text-xs-center">
                <div>
                  <v-btn
                    :disabled="!props.item.painter_works || !props.item.painter_works.length"
                    @click="showImageWork(props.item.painter_works)"
                  >
                    <em class="fas fa-image mr-2" /> ดูรูปผลงาน ({{
                      props.item.painter_works ? props.item.painter_works.length : 0
                    }})
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-container>
    <div v-if="showImage">
      <Tinybox v-model="index" :images="currentImages" loop />
    </div>
  </div>
</template>

<script>
import api from '@/api'
import DateFilter from '@/components/view/dashboard/DateFilter.vue'
import { mapGetters } from 'vuex'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import Tinybox from 'vue-tinybox'

export default {
  components: {
    DateFilter,
    Multiselect,
    Tinybox
  },
  data() {
    return {
      currentImages: [],
      showImage: false,
      index: null,
      dealertype: {
        label: 'ช่างที่กดยืนยันรับงาน',
        value: 'painterconfirmjobdashboard'
      },
      optionType: [
        {
          label: 'ช่างที่กดยืนยันรับงาน',
          value: 'painterconfirmjobdashboard'
        },
        {
          label: 'ช่างที่ได้รับการรีวิว',
          value: 'painterreviewjobdashboard'
        },
        {
          label: 'ช่างที่กดส่งคำขอเริ่มงาน',
          value: 'paintersendstartdatejobdashboard'
        },
        {
          label: 'ช่างที่กดยกเลิกงาน',
          value: 'paintercanceledjobdashboard'
        },
        {
          label: 'ช่างที่กดอัพเดตงานลูกค้า',
          value: 'painterupdatejobdashboard'
        }
      ],
      loading: false,
      selectedDate: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD')
      },
      pagination: { sortBy: 'none', descending: true, rowsPerPage: 25 },
      data: [],
      total: 0,
      headers: [
        { text: 'ชื่อช่าง', value: 'painter_name', align: 'center', width: '1%' },
        { text: 'เบอร์โทรศัพท์', value: 'painter_phoneno', align: 'center', width: '1%' },
        { text: 'อีเมล', value: 'painter_email', align: 'center', width: '1%' },
        { text: 'ประสบการณ์ทำงาน', value: 'painter_experience', align: 'center', width: '1%' },
        { text: 'ที่อยู่ช่าง', value: 'painter_addres1', align: 'center', width: '1%' },
        { text: 'รูปผลงาน', value: 'painter_works', align: 'center', width: '1%' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    showImageWork(images) {
      this.currentImages = images
      this.showImage = true
      this.index = 0
    },
    onChangeType() {},
    getData() {
      return new Promise((resolve) => {
        var data = {
          pageid: this.selectedBot.pageid,
          datefrom: moment(this.selectedDate.start).format('YYYY-MM-DD'), // YYYY-MM-DD
          dateto: moment(this.selectedDate.end).format('YYYY-MM-DD') // YYYY-MM-DD
        }
        this.loading = true
        api[this.dealertype.value](data, (err, response) => {
          this.loading = false
          try {
            this.data = response.data.map((el) => {
              return JSON.parse(el.painterinfo)
            })
          } catch (error) {
            this.data = []
          }
          if (response.total) {
            this.total = response.total
          } else {
            this.total = 0
          }
          resolve()
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toa/Painter/painterbystatus.vue